<template>
  <nav v-if="navColumns.length" class="root gap-x-8 gap-y-8 grid" :aria-label="$t('footer.ariaNavigation')">
    <div v-for="(group, idxA) in navColumns" :key="idxA" class="gap-y-8 md:text-left grid text-center">
      <div v-for="(block, idxB) in group.blocks" :key="idxB">
        <div v-for="(item, idxC) in block.links" :key="idxC">
          <h3 v-if="idxC === 0" class="fluid-xs leading-snug uppercase font-medium mb-2">
            <LinkField
              v-bind="item.link[0]"
              class="hover:opacity-60 inline-block transition-opacity"
              no-tracking
              @click.native="handleNavClick(block, idxC)"
            />
          </h3>
          <LinkField
            v-else
            v-bind="item.link[0]"
            class="hover:opacity-60 fluid-xs leading-tightest inline-block mb-2 transition-opacity"
            no-tracking
            @click.native="handleNavClick(block, idxC)"
          />
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
import { snakeCase } from 'lodash-es';
import gql from 'graphql-tag';
import LinkField from '@/components/common/LinkField';
import { useMainNavStore } from '@/stores/main-nav';

export const FooterNavFragment = gql`
  fragment FooterNavFragment on footerNav_GlobalSet {
    blocks: footerNavBlocks {
      ... on footerLinkSection_Entry {
        startNewColumn
        links: footerNavLinkSectionLinks {
          ... on footerNavLinkSectionLinksBlock_Entry {
            link: linkField {
              ...LinkFragment
            }
          }
        }
      }
    }
  }
`;

export default defineNuxtComponent({
  components: { LinkField },
  props: {
    nav: {
      type: Object,
      default: () => ({}),
    },
  },
  setup() {
    const mainNavStore = useMainNavStore();
    return { mainNavStore };
  },
  computed: {
    /**
     * split blocks into columns
     * @returns {array} of arrays of blocks
     */
    navColumns() {
      return this.splitBlocksIntoColumns(this.nav?.blocks);
    },
  },
  methods: {
    splitBlocksIntoColumns(blocks) {
      const columns = [];
      let currentColumnIndex = 0;

      blocks?.forEach((block, i) => {
        if (this.isNewColumn(block, i)) {
          columns.push({ blocks: [block] });
          currentColumnIndex++;
        } else {
          columns[currentColumnIndex].blocks.push(block);
        }
      });

      return columns;
    },
    isNewColumn(block, index) {
      return index === 0 || block.startNewColumn || block.typeHandle === 'imageFeature';
    },
    getLinkText(block, index) {
      const item = block?.links?.[index];
      return item?.link?.[0]?.text ?? '';
    },
    handleNavClick(block, idxC) {
      const sectionLabel = snakeCase(this.getLinkText(block, 0));
      const segment = snakeCase(this.getLinkText(block, idxC));
      const pathParts = sectionLabel ? [sectionLabel] : [];
      if (idxC > 0 && segment) pathParts.push(segment);
      const path = pathParts.join('>');

      this.$_pushNavigationEvent('footer', path || 'footer');
      this.mainNavStore.setActiveNavItemIndex(null);
    },
  },
});
</script>

<style scoped>
@reference "~/assets/css/main.css";
.root {
  grid-template-columns: repeat(1, 1fr);
}

@media (width >= 768px) {
  .root {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (width >= 1024px) {
  .root {
    grid-template-columns: repeat(4, 1fr);
  }
}
</style>
